import React from "react";
import DeleteModal from "../DeleteModal";

const OrdersTab = ({
  t,
  userOrders = [],
  showDropdown,
  toggleDropdown,
  handleCancelOrder,
  handleReactivateOrder,
  setOrderToDelete,
  setShowDeleteOrderModal,
  showDeleteOrderModal,
  confirmDeleteOrder,
  navigate,
}) => {
  const hasOrders = Array.isArray(userOrders) && userOrders.length > 0;

  return (
    <div className="tab-content">
      <h2 onClick={() => toggleDropdown("orders")}>
        {t("account.order_history")} {showDropdown ? "▼" : "▶"}
      </h2>

      {/* If no orders at all -> show empty state (open or closed) */}
      {!hasOrders && (
        <div>
          <p>{t("account.no_orders")}</p>
          <button onClick={() => navigate("/pricing")} className="add-btn">
            {t("account.new_subscription")}
          </button>
        </div>
      )}

      {/* If there ARE orders -> only render the list when opened */}
      {hasOrders && showDropdown && (
        <div className="order-section">
          {userOrders.map((order) => (
            <div
              key={order.id || order.createdAt}
              className={`order-entry ${
                order.status === "cancelled" ? "cancelled" : ""
              }`}
            >
              <p className="order-plan">
                {t("account.subscription_plan")}: {order.plan}
              </p>
              <p className="order-date">
                {t("account.order_date")}:{" "}
                {order.createdAt?.toDate
                  ? new Date(order.createdAt.toDate()).toLocaleString()
                  : new Date(order.createdAt || Date.now()).toLocaleString()}
              </p>
              <p className="order-status">
                {t("account.status")}: {order.status}
              </p>

              {order.invoice && (
                <a href={order.invoice} download className="download-invoice">
                  {t("account.download_invoice")}
                </a>
              )}

              <div className="order-actions">
                {order.status === "cancelled" ? (
                  <>
                    <button
                      className="reactivate-btn"
                      onClick={() => handleReactivateOrder(order.id)}
                    >
                      {t("account.reactivate_subscription")}
                    </button>
                    <button
                      className="add-btn"
                      onClick={() => navigate("/pricing")}
                    >
                      {t("account.new_subscription")}
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => {
                        setOrderToDelete(order.id);
                        setShowDeleteOrderModal(true);
                      }}
                    >
                      {t("account.delete_order")}
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="upgrade-btn"
                      onClick={() => navigate("/pricing")}
                    >
                      {t("account.upgrade_plan")}
                    </button>
                    <button
                      className="cancel-btn"
                      onClick={() => handleCancelOrder(order.id)}
                    >
                      {t("account.cancel_subscription")}
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {showDeleteOrderModal && (
        <DeleteModal
          title={t("account.confirm_delete_order_title")}
          message={t("account.confirm_delete_order_message")}
          confirmText={t("account.delete_order_yes")}
          cancelText={t("account.cancel")}
          onConfirm={confirmDeleteOrder}
          onCancel={() => setShowDeleteOrderModal(false)}
        />
      )}
    </div>
  );
};

export default OrdersTab;
